import { Component, Input, Output, EventEmitter } from "@angular/core";

/**
 * This component represents "toggle checkbox"
 * This component allows user to check/uncheck the option
 */

@Component({
  selector: "app-toggle-checkbox",
  templateUrl: "./toggle-checkbox.component.html",
  styleUrls: ["./toggle-checkbox.component.scss"],
})
export class ToggleCheckboxComponent {
  @Input() disabled: boolean;
  @Input() checkboxValue: boolean;
  @Input() title = "Blank Rows";
  @Input() label = "Show";
  @Input() labelInfo: string;
  @Output() onCheckboxChange = new EventEmitter();

  /**
   * Executes on change of switch value
   * Emits `onCheckboxChange` with selected value
   */
  handleCheckboxChange(value) {
    this.onCheckboxChange.emit(value);
  }
}
